module.exports = __webpack_public_path__ + "img/loading.2514653c.svg";